export const FPS = 30;
export const WIDTH = 1920;
export const HEIGHT = 1080;

export const COLORS = {
  bg: "#050B18",
  bgCard: "#121D38",
  bgCardLight: "#1A2548",
  neonPink: "#FF2D95",
  neonBlue: "#00D4FF",
  neonPurple: "#A855F7",
  neonGreen: "#00FF88",
  neonOrange: "#FF6B35",
  neonYellow: "#FFD60A",
  neonCyan: "#00E5FF",
  neonRed: "#FF3366",
  neonLime: "#84FF57",
  textPrimary: "#FFFFFF",
  textSecondary: "#B8C5E0",
  textMuted: "#6B7DA0",
};

export const FONTS = {
  heading: "Inter, SF Pro Display, system-ui, sans-serif",
  body: "Inter, SF Pro Text, system-ui, sans-serif",
  mono: "JetBrains Mono, SF Mono, Fira Code, monospace",
};

export const SPRING = {
  snappy: { damping: 200, mass: 0.5 },
  bouncy: { damping: 100, mass: 0.5 },
  gentle: { damping: 150, mass: 0.8 },
  slow:   { damping: 120, mass: 1.2 },
  punch:  { damping: 80,  mass: 0.4 },
};

// 18 scenes — ~5min total
export const SCENE = {
  cold:       { start:    0, duration: 300 }, //  0- 10s  — "Your data is leaking"
  title:      { start:  300, duration: 240 }, // 10- 18s  — "Security First"
  threats:    { start:  540, duration: 300 }, // 18- 28s  — 3 threats intro
  threat1:    { start:  840, duration: 600 }, // 28- 48s  — Tenant bleed-through
  threat2:    { start: 1440, duration: 600 }, // 48- 68s  — Web exfiltration
  threat3:    { start: 2040, duration: 600 }, // 68- 88s  — Credential sprawl
  enter:      { start: 2640, duration: 240 }, // 88- 96s  — Enter EAKC transition
  pillar1:    { start: 2880, duration: 750 }, // 96-121s  — Postgres RLS
  rlsDemo:    { start: 3630, duration: 750 }, //121-146s  — Cross-tenant block viz
  pillar2:    { start: 4380, duration: 600 }, //146-166s  — Self-hosted airgapped
  pillar3:    { start: 4980, duration: 450 }, //166-181s  — Open embeddings
  pillar4:    { start: 5430, duration: 600 }, //181-201s  — Web nudge
  pillar5:    { start: 6030, duration: 600 }, //201-221s  — Scoped MCP keys
  pillar6:    { start: 6630, duration: 600 }, //221-241s  — Strict source
  pillar7:    { start: 7230, duration: 450 }, //241-256s  — Audit logs
  summary:    { start: 7680, duration: 600 }, //256-276s  — Security BOM
  compliance: { start: 8280, duration: 450 }, //276-291s  — Compliance ready
  outro:      { start: 8730, duration: 270 }, //291-300s  — CTA
};

export const TOTAL_DURATION = 9000; // 300s = 5min

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
